module.exports = __webpack_public_path__ + "static/media/facebook.4a30b94b.svg";